const cleanNewRecord = (record: Record<string, any>, identifierKey: string): Record<string, any> => {
  if (record[identifierKey]) return record; // existing record untouched

  const cleaned = { ...record };
  delete cleaned[identifierKey];
  delete cleaned.DiscographyAlbumIdentifier;
  delete cleaned.DateAdded;
  delete cleaned.DateModified;
  delete cleaned.AddedBy;
  delete cleaned.ModifiedBy;
  delete cleaned.AccountNumber;
  if (!cleaned.SubmittedDate) delete cleaned.SubmittedDate;
  return cleaned;
};

export default cleanNewRecord;
